const euProduct = {
  product: {
    personalisation: {
      cost: '€10.00'
    },
    'returns-and-exchanges-instructions': {
      lines:
        '5-8 working day delivery - free on orders under €150 | Free EU 200-day returns & exchanges - no questions, no catches | Human customer care - no chatbots'
    }
  }
}

module.exports = euProduct
